import { StyleSheet } from 'react-native';

import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';
import { PlatformUtils } from '@vfgroup-oneplatform/foundation/Utils';

export default StyleSheet.create({
  containerStyle: {
    flex: 1,
  },
  imageContainerStyle: {
    height: 110,
    paddingTop: 20,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  overlayStyle: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    height: 300,
    zIndex: 2,
  },
  logoStyle: {
    ...StyleSheet.absoluteFillObject,
    top: 49,
    left: 17,
  },
  headerStyle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: Colors.white,
  },
  safeViewStyle: {
    paddingTop: PlatformUtils.isIPhoneDeviceWithNotch() ? 17 : 0,
  },
});
